module.exports = __webpack_public_path__ + "static/media/howtofy_logo_white_RGB.8e8be198.svg";